module.exports = __webpack_public_path__ + "static/tertiary-ae3b5e2ca3127ae563b9406bd526f56c.png";